import { resolveAdminPermission } from './adminPermissionCatalog';

const EVENT_DETAIL_VIEW_PERMISSION_ITEMS = [
  {
    key: 'EVENT_VIEW_CASTING_SETTINGS',
    label: 'キャスティング設定を表示',
    description: 'キャスティング設定パネルを表示します。',
  },
  {
    key: 'EVENT_VIEW_PARTICIPANTS',
    label: '参加アーティストを表示',
    description: '参加アーティスト一覧・プロフィール情報を表示します。',
  },
  {
    key: 'EVENT_VIEW_TICKET_SALES',
    label: '券売状況を表示',
    description: '券売サマリー・推移・販路情報を表示します。',
  },
  {
    key: 'EVENT_VIEW_GUEST_TICKETS',
    label: '取り置き・招待を表示',
    description: '取り置き・招待の枠、登録者、利用状況を表示します。',
  },
  {
    key: 'EVENT_VIEW_MARKETING',
    label: 'マーケティングを表示',
    description: 'マーケティング戦略・施策・実施記録・効果・学びを表示します。',
  },
  {
    key: 'EVENT_VIEW_EVENT_TASKS',
    label: 'イベントタスクを表示',
    description: 'イベントに紐づくタスクの進捗・注目タスクを表示します。',
  },
  {
    key: 'EVENT_VIEW_TIMETABLE',
    label: 'タイムテーブルを表示',
    description: 'タイムテーブルのプレビューを表示します。',
  },
  {
    key: 'EVENT_VIEW_MATERIALS',
    label: 'イベント資料を表示',
    description: '資料一覧を表示します。',
  },
  {
    key: 'EVENT_DOWNLOAD_MATERIALS',
    label: 'イベント資料をダウンロード',
    description: 'イベント資料ファイルをダウンロードできます。',
  },
  {
    key: 'EVENT_VIEW_MATERIAL_DOWNLOAD_LOGS',
    label: 'イベント資料DL履歴を表示',
    description: 'イベント資料のダウンロード履歴を表示します。',
  },
  {
    key: 'EVENT_VIEW_IMAGES',
    label: 'イベントアルバムを表示',
    description: 'イベントアルバムを表示します。',
  },
  {
    key: 'EVENT_DOWNLOAD_IMAGES',
    label: 'イベントアルバムをダウンロード',
    description: 'イベントアルバムの画像をダウンロードできます。',
  },
  {
    key: 'EVENT_VIEW_CONTRACT_STATUS',
    label: '契約状況を表示',
    description: '契約送付済みアーティストの契約ステータスを表示します。',
  },
];

const EVENT_DETAIL_EDIT_PERMISSION_ITEMS = [
  {
    key: 'EVENT_EDIT_INFO',
    label: 'イベント基本情報を変更',
    description: 'イベント情報の修正やフライヤー/バナー更新を行えます。',
  },
  {
    key: 'EVENT_EDIT_CASTING_SETTINGS',
    label: 'キャスティング設定を変更',
    description: 'キャスティング設定系の操作（設定/参加者パート設定等）を行えます。',
  },
  {
    key: 'EVENT_EDIT_PARTICIPANTS',
    label: '参加アーティスト設定を変更',
    description: '参加者公開設定など、参加アーティスト関連設定を変更できます。',
  },
  {
    key: 'EVENT_EDIT_TICKET_SALES',
    label: '券売状況を変更',
    description: '券売状況の登録・更新操作を行えます。',
  },
  {
    key: 'EVENT_EDIT_GUEST_TICKETS',
    label: '取り置き・招待を変更',
    description: '取り置き・招待の登録、支払、来場、取消を更新できます。',
  },
  {
    key: 'EVENT_MANAGE_GUEST_TICKET_ALLOCATIONS',
    label: '取り置き・招待枠を管理',
    description: '参加者ごとの枠、入力項目、通知を管理できます。',
  },
  {
    key: 'EVENT_SHARE_TICKET_SALES',
    label: '券売状況をアーティストへ共有',
    description: '券売枚数・残り枚数・販売率の共有範囲と通知を変更できます。',
  },
  {
    key: 'EVENT_EDIT_MARKETING',
    label: 'マーケティングを変更',
    description: 'マーケティング戦略・施策・実施記録・効果・学びを変更できます。',
  },
  {
    key: 'EVENT_EDIT_EVENT_TASKS',
    label: 'イベントタスクを変更',
    description: 'イベントタスクの作成・編集・完了操作を行えます。',
  },
  {
    key: 'EVENT_EDIT_TIMETABLE',
    label: 'タイムテーブルを変更',
    description: 'タイムテーブル設定画面への遷移・編集を行えます。',
  },
  {
    key: 'EVENT_EDIT_MATERIALS',
    label: 'イベント資料を変更',
    description: '資料の追加・編集・削除・共有設定変更を行えます。',
  },
  {
    key: 'EVENT_EDIT_IMAGES',
    label: 'イベントアルバムを変更',
    description: 'イベントアルバムへの追加とフォルダ作成を行えます。',
  },
  {
    key: 'EVENT_DELETE',
    label: 'イベントを削除',
    description: 'イベント削除と削除可否確認を実行できます。',
  },
];

const EVENT_DETAIL_PERMISSION_ITEMS = [
  ...EVENT_DETAIL_VIEW_PERMISSION_ITEMS,
  ...EVENT_DETAIL_EDIT_PERMISSION_ITEMS,
];

const EVENT_DETAIL_PERMISSION_KEYS = EVENT_DETAIL_PERMISSION_ITEMS.map((item) => item.key);
const EVENT_DETAIL_PERMISSION_KEY_SET = new Set(EVENT_DETAIL_PERMISSION_KEYS);

const normalizeRole = (role) => String(role || '').trim().toLowerCase() || 'general';

const normalizePermissionList = (permissions) => {
  if (Array.isArray(permissions)) {
    return Array.from(new Set(permissions.map((perm) => String(perm || '').trim()).filter(Boolean)));
  }
  if (permissions === '*' || permissions === 'admin') {
    return ['*'];
  }
  if (permissions) {
    const single = String(permissions).trim();
    return single ? [single] : [];
  }
  return [];
};

const EVENT_DETAIL_EDIT_PERMISSION_KEY_SET = new Set(
  EVENT_DETAIL_EDIT_PERMISSION_ITEMS.map((item) => item.key)
);

const isEventDetailEditPermission = (permissionKey) =>
  EVENT_DETAIL_EDIT_PERMISSION_KEY_SET.has(String(permissionKey || '').trim());

const getDefaultEventDetailPermissionValue = (permissionKey, role = 'general') => {
  if (!EVENT_DETAIL_PERMISSION_KEY_SET.has(permissionKey)) return false;
  return resolveAdminPermission({
    role: normalizeRole(role),
    permissions: [],
    permissionKey,
  });
};

const resolveEventDetailPermission = ({
  role,
  permissions,
  permissionKey,
  isExternalAccount = false,
}) => {
  const normalizedRole = normalizeRole(role);
  const normalizedPermissions = normalizePermissionList(permissions);
  if (!EVENT_DETAIL_PERMISSION_KEY_SET.has(permissionKey)) return false;
  return resolveAdminPermission({
    role: normalizedRole,
    isExternalAccount,
    permissions: normalizedPermissions,
    permissionKey,
  });
};

const buildEffectiveEventDetailPermissionMap = ({ role, permissions }) => {
  const normalizedRole = normalizeRole(role);
  const normalizedPermissions = normalizePermissionList(permissions);
  const map = {};
  EVENT_DETAIL_PERMISSION_KEYS.forEach((permissionKey) => {
    map[permissionKey] = resolveEventDetailPermission({
      role: normalizedRole,
      permissions: normalizedPermissions,
      permissionKey,
    });
  });
  return map;
};

const applyEventDetailPermissionToggle = ({
  role,
  permissions,
  permissionKey,
  enabled,
}) => {
  if (!EVENT_DETAIL_PERMISSION_KEY_SET.has(permissionKey)) {
    return normalizePermissionList(permissions);
  }
  const normalizedRole = normalizeRole(role);
  const normalizedPermissions = normalizePermissionList(permissions);
  const nonEventPermissions = normalizedPermissions.filter(
    (perm) => !EVENT_DETAIL_PERMISSION_KEY_SET.has(perm)
  );
  const map = buildEffectiveEventDetailPermissionMap({
    role: normalizedRole,
    permissions: normalizedPermissions,
  });
  map[permissionKey] = Boolean(enabled);
  if (normalizedRole === 'task_only') {
    EVENT_DETAIL_EDIT_PERMISSION_ITEMS.forEach((item) => {
      map[item.key] = false;
    });
  }
  const nextEventPermissions = EVENT_DETAIL_PERMISSION_KEYS.filter((perm) => map[perm]);
  return Array.from(new Set([...nonEventPermissions, ...nextEventPermissions]));
};

const isEventDetailPermissionKey = (permissionKey) =>
  EVENT_DETAIL_PERMISSION_KEY_SET.has(String(permissionKey || '').trim());

export {
  EVENT_DETAIL_VIEW_PERMISSION_ITEMS,
  EVENT_DETAIL_EDIT_PERMISSION_ITEMS,
  EVENT_DETAIL_PERMISSION_ITEMS,
  EVENT_DETAIL_PERMISSION_KEYS,
  isEventDetailPermissionKey,
  isEventDetailEditPermission,
  getDefaultEventDetailPermissionValue,
  resolveEventDetailPermission,
  buildEffectiveEventDetailPermissionMap,
  applyEventDetailPermissionToggle,
};
